import { OptionEntity } from 'src/store/optionApi';
import { useRef } from 'react';
import Editor, { EditorRef } from './editor';
import Content from './content';

export interface OptionProps {
  refetchAll: () => void;
}

const Options = ({ refetchAll }: OptionProps) => {
  const editorRef = useRef<EditorRef>(null);
  const onSelectOption = (option: OptionEntity) => {
    editorRef.current?.onSelect(option);
  };

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '300px 1fr',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <Content
        setSelectedOption={onSelectOption}
        onCreate={() => editorRef.current?.onCreate()}
      />
      <Editor ref={editorRef} refetchAll={refetchAll} />
    </div>
  );
};

export default Options;
